import { RETRY as RETRY_FROM_LIB } from '@apeiron/temp'
import * as R from 'ramda'

const RETRY_FROM_MARLETPLACE = {
  CONTRACT: {
    BORN: { forever: true, minTimeout: 2000, factor: 1, retries: 50 },
    BREED: { forever: true, minTimeout: 2000, factor: 1, retries: 50 }
  }
}

export const RETRY = R.mergeDeepRight(RETRY_FROM_LIB, RETRY_FROM_MARLETPLACE)
